export class TimeoutError extends Error {
    public name = 'TimeoutError';
    public timeout: number | null;

    constructor(message: string, timeout: number | null = null) {
        super();
        this.message = message;
        this.timeout = timeout;
    }
}
